// Sales routes: customers, quotations, invoices, credit notes
import Customers from '../pages/Customers';
import CustomerDetails from '../pages/CustomerDetails';
import CustomerReport from '../pages/CustomerReport';
import CustomerStatement from '../pages/CustomerStatement';
import CustomerTimeline from '../pages/CustomerTimeline';
import Invoices from '../pages/Invoices';
import CreditNotes from '../pages/CreditNotes';
import Quotations from '../pages/Quotations';
import QuotationAnalytics from '../pages/QuotationAnalytics';
import QuotationApprovals from '../pages/QuotationApprovals';
import SalesQuotations from '../pages/SalesQuotations';
import Contracts from '../pages/Contracts';
import LeadsConsole from '../pages/LeadsConsole';
import RfqConsole from '../pages/RfqConsole';

const salesRoutes = [
  { path: '/customers', Component: Customers, withUser: true },
  { path: '/customers/:customerId', Component: CustomerDetails },
  { path: '/customers/:customerId/timeline', Component: CustomerTimeline },
  { path: '/customer-report', Component: CustomerReport },
  { path: '/customer-statement', Component: CustomerStatement },
  { path: '/customer-statement/:customerId', Component: CustomerStatement },
  { path: '/invoices', Component: Invoices, withUser: true },
  { path: '/credit-notes', Component: CreditNotes, withUser: true },
  { path: '/quotations', Component: Quotations, withUser: true },
  { path: '/quotation-analytics', Component: QuotationAnalytics },
  { path: '/quotation-approvals', Component: QuotationApprovals },
  { path: '/sales-quotations', Component: SalesQuotations },
  { path: '/contracts', Component: Contracts },
  { path: '/leads-console', Component: LeadsConsole },
  { path: '/rfq-console', Component: RfqConsole },
];

export default salesRoutes;
